import AddIcon from '@mui/icons-material/Add';
import { AlignMobileButton } from 'v3/pages/Contracting/Details/styles';
import { CircularButton } from 'v3/shared/components/Button/CircularButton';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TabsEnum } from 'v3/shared/enums/tabs-emun';

interface AddGroupButtonProps {
  tabValue: TabsEnum;
  isDesktop: boolean;
  onClickGroup: () => void;
  onClickAdmin: () => void;
}

export const AddGroupButton = ({ tabValue, isDesktop, onClickGroup, onClickAdmin }: AddGroupButtonProps) => {
  const isGroupTab = tabValue === TabsEnum.GroupTab;

  const handleClick = isGroupTab ? onClickGroup : onClickAdmin;
  const buttonText = isGroupTab ? 'Adicionar grupo' : 'Adicionar grupo admin';

  return isDesktop ? (
    <FlexButton text={buttonText} startIcon={AddIcon} size="small" handleClick={handleClick} />
  ) : (
    <AlignMobileButton>
      <CircularButton startIcon={AddIcon} handleClick={handleClick} />
    </AlignMobileButton>
  );
};
